// Import of actions
import * as ManualItemActions from "../actions/manual-item.actions";
import { IManualItem } from "../../models/manual-item";

export type ManualItemState = IManualItem[];

export const initialState: IManualItem[] = [];

export function manualItemReducer(
  state = initialState,
  action: ManualItemActions.Actions
): ManualItemState {
  switch (action.type) {
    case ManualItemActions.RESET_STATE: {
      return initialState;
    }

    case ManualItemActions.ADD: {
      return state.find(item => item.id === action.payload.id)
        ? state
        : [...state, action.payload];
    }

    case ManualItemActions.REPLACE: {
      return [
        ...state.filter(
          item => item.id !== action.payload.id
        ),
        action.payload // payload is FHIR resource
      ];
    }

    case ManualItemActions.REPLACE_MULTIPLE: {
      const replacedIds = action.payload.map(elem => elem.id)
      return [
        ...state.filter(
          item => !replacedIds.includes(item.id)
        ),
        ...action.payload // payload is FHIR resource
      ];
    }

    case ManualItemActions.UPDATE: {
      return state.map(item => {
        return item.id === action.payload.id
          ? { ...item, ...action.payload }
          : item;
      });
    }

    case ManualItemActions.DELETE: {
      return state.filter(
        item => item.id !== action.payload.id
      );
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/manual-item.reducer.ts